module.exports = __webpack_public_path__ + "media/public/birdid-27d8ee44.svg";